(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('overflowElement', overflowElement);

        overflowElement.$inject = ['$timeout'];

    function overflowElement($timeout) {
        var scrollParent = null;
        return {
            restrict: 'A',
            scope: false,
            link: function(scope, element, attrs){

                var ELEMENT_HEIGHT = 27;

                scrollParent = getScrollParent(element[0]);

                $timeout(function () {
                    setPositionClasses();
                }, 0);
            
                angular.element(scrollParent).bind('scroll', setPositionClasses);

                function setPositionClasses(){
                    for (let i=0, l=element[0].classList.length; i<l; ++i) {
                        if(/row-near-.*/.test(element[0].classList[i])) {
                            element.removeClass(element[0].classList[i]);
                        }
                    }

                    var distToTop = element[0].offsetTop - scrollParent.scrollTop;
                    if(distToTop < 130){
                        element.addClass('near-top');
                        if(distToTop >= 0){
                            element.addClass('row-near-' + (Math.floor(distToTop / ELEMENT_HEIGHT) + 1));
                        } else{
                            element.addClass('row-near-0');
                        }
                        //element.addClass('row-near-dist-' + distToTop);
                    } else {
                        element.removeClass('near-top');
                    }
                    
                    var distToBottom = scrollParent.clientHeight - (element[0].offsetTop - scrollParent.scrollTop);
                    if(distToBottom < 150){
                        element.addClass('near-bottom');
                        if((distToBottom - ELEMENT_HEIGHT) >= 0){
                            element.addClass('row-near-' + Math.floor(distToBottom / ELEMENT_HEIGHT) );
                        } else {
                            element.addClass('row-near-0');
                        }
                        //element.addClass('row-near-dist-' + distToBottom);
                    } else {
                        element.removeClass('near-bottom');
                    }
                }
            }
        };

        
        function getScrollParent(node) {
            if (node == null) {
              return null;
            }
           
            if (node.style && (node.style.overflow === 'scroll' || node.style.overflow === 'hidden')) {
              return node;
            } else {
              return getScrollParent(node.parentNode);
            }
          }
    }
})();